export default "__VITE_ASSET__BObMlqvI__"